import React from 'react';

import { STATIC_ROOT, BRAND_NAME } from '../../../constants';

import './ModalHeaderComponent.scss';

export const ModalHeaderComponent = ({ urlRewritten, partner, i18n }) => {
    return (
        <section className="interstitiel-modal-header flex-container-h flex-center-alt">
            <img src={`${STATIC_ROOT}/logo.png`} alt={BRAND_NAME} width="87" height="35" />
            {partner && urlRewritten && (
                <div>
                    {i18n.HEADER_MSG}
                    <a href={urlRewritten} title={partner ? partner.name : ''}>
                        {i18n.CLICK_HERE}
                    </a>
                </div>
            )}
        </section>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/ModalHeaderComponent.js